import { Text } from '@chakra-ui/react'

export default Text
